import { Project } from '../../model/editor/Project';
import {HttpHeaders} from "@angular/common/http";
import {CognitoUtil, LoggedInCallback} from "../service-auth/cognito.service";
import {environment} from "../../environments/environment";
import {CognitoUserPool} from "amazon-cognito-identity-js";
import {UserLoginService} from "../service-auth/user-login.service";
import {NotificationsService} from "../service-data/notifications.service";
import {Router} from "@angular/router";
import {AlertService} from "./alert.service";
import {CoverTheme} from "../../model/editor/CoverTheme";
import {InteriorTheme} from "../../model/editor/interior-theme/InteriorTheme";
import {FontItem} from "../../model/font/FontItem";
import {Cart} from "../../model/cart/Cart";
import {Cover} from "../../model/editor/Cover";
import {Chapter} from "../../model/editor/Chapter";
import {Subscription} from "../../model/Subscription";
import {FileUploader} from "../file-upload/file-uploader.class";
import {User} from "../../model/User";
import * as JWT from 'jwt-decode';
import {CanvasManager} from "../../canvas-manager/CanvasManager";
import {ColorPalette} from "../../model/color/ColorPalette";
import {Product} from "../../model/Product";
import {Draft} from "../../model/Draft";
import {Book} from "../../model/Book";
import { Injectable } from "@angular/core";
import {OrganizationService} from "../service-data/organization.service";
import {DataService} from "../service-data/data-service";
import {Organization} from "../../model/Organization";
import {Observable, Subject} from "rxjs";
import {PackageAndShippingComputationService} from "../service-data/package-and-shipping-computation.service";
import {MeasurementUnits, UnitSystem} from "./measurement-units";
import {parseRoleOptions, readCognitoGroups, resolveRoleSelection} from "./roleSelection";

@Injectable()
export class StartupService implements LoggedInCallback, RoleChangeNotifier {

  public static darkColorAliases = {
    'errorBackground': 'darkred',
    'errorAndSelectedBackground': 'darkorange',
    'selectedBackground': 'goldenrod',
    'background1': 'darkred',
    'background2': 'darkgreen',
    'background3': 'darkblue',
    'background4': 'darkgrey',
    'background5': 'darkorange',
    'background6': 'darkgreen',
    'background7': 'blue',
    'background8': 'brown',
    'background9': 'orange',
    'highPriorityColor': 'pink',
    'normalPriorityColor' : 'darkyellow',
    'normalColor' : 'white',
    '' : ''
  };
  public static colorAliases = {
    'errorBackground': 'red',
    'errorAndSelectedBackground': 'orange',
    'selectedBackground': 'lightsalmon',
    'background1': 'lightgoldenrodyellow',
    'background2': 'lightgreen',
    'background3': 'lightblue',
    'background4': 'lightgrey',
    'background5': 'orange',
    'background6': 'lightgreen',
    'background7': 'blue',
    'background8': 'brown',
    'background9': 'orange',
    'highPriorityColor': 'pink',
    'normalPriorityColor' : 'lightyellow',
    'normalColor' : 'white',
    '' : ''
  };

  onDestroySubject: Subject<boolean> = new Subject();

  public colorAliases = StartupService.colorAliases;
  // Project focus related properties
  selectedChapter: Chapter;
  selectedCover: Cover;
  showStructure: boolean = true;
  showCoverTools: boolean = true;
  showInteriorTools: boolean = true;
  showUpload: boolean = false;
  showUploadCheckout: boolean = false;
  showUpdateRecurring: boolean = false;

  floatingToolStripLeft: boolean = false;
  showInactiveCoverThemeItems: boolean = false;
  admin: boolean = false;
  private network: boolean = false;
  private serviceProvider: boolean = false;
  inventory: boolean = false;

  // productService: ProductService = undefined;
  // bookService: BookService = undefined;
  // draftService: DraftService = undefined;
  // projectService: ProjectService = undefined;
  // subscriptionService: SubscriptionService = undefined;
  uploader: FileUploader;

  colorPaletteChange: number = 0;
  fontSettingsChange: number = 0;
  coverThemeChange: number = 0;
  trimSizeChange: number = 0;
  registrationRetries = 0;
  public coverThemes: CoverTheme[];
  public interiorThemes: InteriorTheme[];
  public fonts: FontItem[];
  public colorPalettes: ColorPalette[];
  public project: Project;
  public product: Product;
  public products: Product[] = [];
  public drafts: Draft[] = [];
  public books: Book[] = [];
  public editorDocument: Document;
  selectedElements: any[];

  public dir: string = 'ltr';
  public lang: string = 'en';

  /**
   * Measurement system every on-screen quantity is rendered in.
   *
   * Authoritative for the whole app: `MeasurementUnits` (and therefore
   * the `measureLength` / `measureWeight` / `measureVolume` /
   * `measurePoints` / `unitLabel` pipes) reads whatever was last
   * pushed in by `setDisplayUnitSystem()`.
   *
   * The value comes from the current Organization
   * (`Organization.displayUnitSystem`). That column does not exist
   * server-side yet -- until it does, `applyOrganizationDisplayUnits()`
   * sees `undefined` and `MeasurementUnits.normalizeUnitSystem()`
   * falls back to `IMPERIAL`, which is exactly what the app rendered
   * before, so nothing changes on screen until the field ships.
   *
   * Stored values are NOT affected by this: lengths stay in inches,
   * weights in pounds, volumes in cubic inches and book geometry in
   * points. This only controls presentation.
   */
  public displayUnitSystem: UnitSystem = 'IMPERIAL';

  public canvasManager: CanvasManager = undefined;
  public cart: Cart = undefined;
  private jwtToken: string;
  private email: string;
  private name: string;
  private phone_number: string;
  private role: string;
  private roleId: string;
  private userId: string;
  private user: User;
  public roleOptions: any = [];
  /**
   * True when the signed-in Cognito account has no role at all — neither a
   * usable `cognito:groups` entry nor a `custom:role` / `custom:roleId` pair.
   *
   * **An empty `cognito:groups` on its own does NOT mean this.** Most accounts
   * have no groups and carry their single role on the custom attributes; they
   * are completely set up and simply have no alternative role to switch to.
   * Flagging those was a regression that showed the majority of users a
   * warning about a perfectly good account.
   *
   * The genuine case is an account that is real and signed in with nothing
   * behind it — where a migrating legacy user lands if the PostConfirmation
   * trigger did not complete. Set in `setJwtToken()` and cleared at the start
   * of every new session, so a later sign-in that repairs the account also
   * clears the warning.
   *
   * Rendered by `StartupComponent`; without it that screen shows "Loading
   * Data" with no cards indefinitely, which reads as a broken application
   * rather than as something the user can act on.
   */
  public accountSetupIncomplete: boolean = false;
  public selectedRole: string;
  public selectedRoleId: string;
  public selectedRoleName: string;


  public limitToOnlyCSVAndOrderHistory = false;
  public showLanguagesOptions = true;

  private subscription: Subscription;
  private subscriptionToken: string;

  public showAudioCertantity = true;
  public useBookWidthInEditor = true;
  public showCurrentlySelectedElementInteriorStyles = true;

  private lastUserActivityTimestamp = Date.now();
  private sessionRefreshTimstamp = Date.now();

  public ready: string = 'NOT_READY';

  private alertService: AlertService;
  private router: Router;
  private userLoginService: UserLoginService;
  private notificationsService: NotificationsService;
  private packageAndShippingComputationService: PackageAndShippingComputationService;
  private organizationService: OrganizationService;

  private FREQUENCY_TO_CHECK_REFRESH = 3; // Three minutes
  private MINUTES_OF_INACTIVITY_TO_WARN = 10 * this.FREQUENCY_TO_CHECK_REFRESH;
  private MINUTES_OF_INACTIVITY_TO_LOGOUT = this.MINUTES_OF_INACTIVITY_TO_WARN + 10;
  private FREQUENCY_TO_REFRESH_SESSION = 15; // Get a refreshed session about every 15 minutes
  private dataServices: DataService[] = [];
  private roleChangeListeners: RoleChangeListener[] = [];
  private organization: Organization;
  private dataLoadingStatus: {};
  public isDataLoaded: boolean = false;

  /**
   * Short-lived parameters captured from an external callback entry
   * URL (e.g. Shopify app install — see
   * `docs/architecture/routing.md` "External callback entry points"
   * and `docs/contracts/shared/ShopifyAppInstall.md`).
   *
   * Set by `AppComponent.ngOnInit()` from the inbound query string
   * before any data load runs, consumed by
   * `AppComponent.isLoggedIn(_, true)` after Cognito auth succeeds.
   * Cleared after consumption.
   */
  public pendingShopifyParams: {
    shop: string;
    code: string;
    hmac: string;
    timestamp: number;
    state?: string;
    host?: string;
  } | null = null;

  /**
   * Single-use Shopify install nonce captured from `/shopify/link?nonce=...`.
   *
   * Held **in memory only**. It is a bearer credential for a store -- whoever
   * has it can bind that shop to their organization -- so it is deliberately
   * never written to `localStorage` or `sessionStorage`, where it would
   * outlive the tab on a shared machine. In-memory is sufficient because this
   * app signs in with an in-page Cognito call rather than a hosted-UI
   * redirect, so the SPA is never torn down between arriving at the link page
   * and returning to it from login or the role picker.
   *
   * Set by `AppComponent.ngOnInit()` (which also strips it from the address
   * bar), consumed and cleared by `ShopifyLinkComponent`.
   */
  public pendingShopifyLinkNonce: string | null = null;

  /**
   * One-shot route override consumed by
   * `StartupComponent.checkIsLoaded()` when the data-load pipeline
   * completes. When non-null, the startup component navigates to
   * this route as a single Angular `Router.navigate()` argument
   * array (e.g. `['/secure/ecommerce', { ecommerceConnectionId: 123 }]`)
   * instead of the role-default surface, and immediately clears it.
   *
   * Used by external-callback entry flows that need to land the
   * user on a specific in-app destination after the normal startup
   * pipeline completes (e.g. the EcommerceConnection settings page
   * for a freshly installed Shopify store).
   */
  public pendingPostStartupRoute: any[] | null = null;

  constructor() {
    if ( environment.limitToOnlyCSVAndOrderHistory ) {
      this.limitToOnlyCSVAndOrderHistory = true;
    } else {
      // TODO: Put this back
      this.limitToOnlyCSVAndOrderHistory = true;
    }
    this.lastUserActivityTimestamp = Date.now();
    this.sessionRefreshTimstamp = Date.now();
    const refreshIntervalTimerId = setInterval(() => {
      if ( this.notificationsService ) {
        this.notificationsService.sendKeepAlive();
      }
      const minutesFromSessionRefresh = ( Date.now() - this.sessionRefreshTimstamp ) / 60000;
      let minutesFromLastUserActivity = ( Date.now() - this.lastUserActivityTimestamp ) / 60000;
      minutesFromLastUserActivity = 0; // Never time out
      if ( minutesFromLastUserActivity >= this.MINUTES_OF_INACTIVITY_TO_WARN && minutesFromLastUserActivity < this.MINUTES_OF_INACTIVITY_TO_LOGOUT) {
        if ( this.alertService ) {
          this.alertService.warn("You are about to be logged due to inactivity.  Clear this alert to continue.", false);
        }
      }

      if ( minutesFromLastUserActivity >= this.MINUTES_OF_INACTIVITY_TO_LOGOUT ) {
        this.logout();
        // clearInterval(refreshIntervalTimerId);
      }
      if (minutesFromSessionRefresh > this.FREQUENCY_TO_REFRESH_SESSION) {
        if ( minutesFromLastUserActivity < 60 ) {
          this.checkSession(this);
        }
      }
    }, this.FREQUENCY_TO_CHECK_REFRESH * 60000); // Check every five minutes
  }

  addRoleChangeListener(roleChangeListener: RoleChangeListener): void {
    this.roleChangeListeners.push(roleChangeListener);
  }

  logout() {
    this.ready = 'NOT_READY';
    this.admin = false;
    this.inventory = false;
    this.userLoginService.logout();
    this.user = undefined;
    this.subscription = undefined;
    this.coverThemes = undefined;
    this.interiorThemes = undefined;
    this.fonts = undefined;
    this.project = undefined;
    this.editorDocument = undefined;
    this.cart = undefined;
    this.jwtToken = undefined;
    this.email = undefined;
    this.name = undefined;
    this.role = undefined;
    this.roleId = undefined;
    this.userId = undefined;
    this.roleOptions = [];
    this.network = false;
    this.serviceProvider = false;
    this.subscription = undefined;
    this.subscriptionToken = undefined;
    this.registrationRetries = 0;

    this.pendingShopifyParams = null;
    this.pendingPostStartupRoute = null;

    this.notificationsService.stopNotification();
    this.alertService.clear();

    try {
      this.onDestroySubject.next(true);
      this.onDestroySubject.unsubscribe();
    } catch ( e ) {
      console.log(`Problem destroying subject in StartupService.logout()`);
    }


    // Added to deal with user being logged in every other time the browser loads
    const currentUser = this.getCurrentUser();
    if ( currentUser ) {
      currentUser.signOut();
    }
    for ( const dataService of this.dataServices ) {
      dataService.reset();
    }

    this.selectRole('', '', '');
    if ( this.router ) {
      this.router.navigate(['/home/login']);
    }
  }

  setJwtToken(token: string) {
    this.jwtToken = token;
    const jwtDecoded = JWT(this.jwtToken);
    // this.groupRoles = {};
    this.roleOptions = [];
    // Cleared on every new session so a successful sign-in after a repair
    // takes the warning away without needing a reload.
    this.accountSetupIncomplete = false;
    this.network = false;
    this.serviceProvider = false;
    // Parsed and de-duplicated by `roleSelection.ts` so the picker and the
    // decision below cannot disagree about what the groups say.
    this.roleOptions = parseRoleOptions(readCognitoGroups(jwtDecoded));
    // Membership flags stay derived from GROUPS ONLY, deliberately. They mean
    // "this operator holds this membership", which is what revocation removes;
    // deriving them from `custom:role` would hand back a privilege that
    // removing the group was supposed to take away. A group-less operator whose
    // single role is network/serviceProvider therefore has these false — see
    // the note in the 2026-09-01 session entry, that case is open.
    for ( const option of this.roleOptions ) {
      if ( option.role === 'network' ) {
        this.network = true;
      }
      if ( option.role === 'serviceProvider' ) {
        this.serviceProvider = true;
      }
    }
    // Decide role-selection navigation intent. The rules live in
    // `roleSelection.ts` so they can be exercised without Angular — see
    // `tests/RoleSelection.smoke.ts`. Summary:
    //
    //  - Groups win whenever there are any. One option is auto-selected, more
    //    than one sends the operator to the picker.
    //  - **When there are no usable groups the `custom:role` / `custom:roleId`
    //    pair is used.** This is the ORDINARY case, not an edge case: most
    //    accounts have an empty `cognito:groups` and carry their single role
    //    on the custom attributes. Such an account is fully set up; it just has
    //    no alternative role to switch to.
    //  - Only an account with neither is treated as not-yet-set-up.
    //
    // Two bugs previously lived here. The first nested the whole block inside
    // `if (custom:role && custom:roleId)`, so a groups-only account never
    // navigated. The fix over-corrected to groups-only, which left every
    // group-less account with no role selected at all AND — once
    // `accountSetupIncomplete` was added — showed the majority of users a
    // "your account is not ready" warning about a perfectly good account.
    const roleIntent = resolveRoleSelection(jwtDecoded, this.selectedRole, this.selectedRoleId);
    if (roleIntent.kind === 'KEEP') {
      console.log(`New JWT Session but keeping the same role ${this.selectedRole}:${this.selectedRoleId}`);
    } else if (roleIntent.kind === 'SELECT') {
      console.log(`New JWT Session -- selecting role ${roleIntent.role}:${roleIntent.roleId} (from ${roleIntent.source === 'GROUP' ? 'cognito:groups' : 'custom:role/custom:roleId'})`);
      this.selectRole(roleIntent.role, roleIntent.roleId, '');
    } else if (roleIntent.kind === 'CHOOSE') {
      console.log(`New JWT Session -- routing to /secure/selectRole (${this.roleOptions.length} role options)`);
      // Chromeless-ish `SelectRoleComponent` — mounted under
      // `/secure` so it inherits the standard toolbar + SideNav
      // shell. `startupService.isDataLoaded` is false at this
      // point so the SideNav only exposes its Logout link; role-
      // scoped data loading is deferred until the operator picks
      // a role there.
      if (this.router) {
        this.router.navigate(['/secure/selectRole']);
      }
    } else {
      // Neither groups nor custom attributes. The account is real and the
      // sign-in succeeded, but there is nothing behind it — where a migrating
      // legacy user lands if the PostConfirmation trigger did not complete.
      // The console.error is for us; `accountSetupIncomplete` is what
      // StartupComponent renders instead of a loading grid that will never
      // fill.
      console.error(`New JWT Session -- no cognito:groups and no custom:role/custom:roleId; operator cannot proceed. cognito:groups=`, jwtDecoded ? jwtDecoded['cognito:groups'] : undefined);
      this.accountSetupIncomplete = true;
    }
    this.getCurrentOrganization();
    if ( jwtDecoded && jwtDecoded['given_name'] && jwtDecoded['custom:admin'] && jwtDecoded['custom:admin'] === jwtDecoded['given_name'] ) {
      this.admin = true;
    } else {
      this.admin = false;
    }
    if ( jwtDecoded && jwtDecoded['given_name'] && jwtDecoded['custom:inventory'] && jwtDecoded['custom:inventory'] === jwtDecoded['given_name'] ) {
      this.inventory = true;
    } else {
      this.inventory = false;
    }
  }

  getDefaultRoleOptions(fallbackRole: string, fallbackRoleId: string): [string, string] {
    if (this.roleOptions && this.roleOptions.length > 0) {
      if (this.roleOptions && this.roleOptions.length === 1) {
        return [this.roleOptions[0].role, this.roleOptions[0].roleId];
      } else {
        for (let i = 0; i < this.roleOptions.length; i++) {
          if ( this.roleOptions[i].role === 'network') {
            return [this.roleOptions[i].role, this.roleOptions[i].roleId];
          }
        }
        return [fallbackRole, fallbackRoleId];
      }
    } else {
      return [fallbackRole, fallbackRoleId];
    }
  }
  doesSelectedRoleNeedNotification(): boolean {
    if ( this.selectedRole && ( this.selectedRole === 'facility' || this.selectedRole === 'network' || this.selectedRole === 'organization' || this.selectedRole === 'serviceProvider' ) ) { // TODO: umbrella?
      return true;
    }
    return false;
  }

  // group roles seems to be only partially populated in some cases
  hasRoleOptions(): boolean {
    if ( this.roleOptions && this.roleOptions.length > 0) {
      return true;
    }
    return false;
  }

  public isNetwork(): boolean {
    return this.network;
  }

  public isServiceProvider(): boolean {
    return this.serviceProvider;
  }

  /**
   * True when this operator may ship an address the validator would not
   * confirm.
   *
   * ## Why this is not just `isNetwork()`
   *
   * `isNetwork()` is derived from `cognito:groups` ONLY, deliberately, because
   * groups are what revocation removes. That is the right rule for a privilege,
   * and it is kept here: an operator holding the network group may override
   * whatever role they happen to be ACTING as at the time, which is the
   * requirement -- address triage is done from inside an organization's context
   * as often as from the network's.
   *
   * The second clause covers a case the first cannot see. An operator whose
   * ONLY role is network carries it on `custom:role` with no group at all, and
   * for them `isNetwork()` is false -- a known open defect recorded in the
   * 2026-09-01 session notes ("do network and serviceProvider operators always
   * have a cognito group?", still unanswered). Those operators are exactly the
   * people who do address triage, so gating purely on the group would deny the
   * override to its primary audience.
   *
   * `selectedRole` is not a weaker claim than a group in that situation: it is
   * only ever set from a group, or -- when there are no groups at all -- from
   * `custom:role`, which is the same attribute the app already trusts to route
   * that operator. It does inherit the known revocation gap in that fallback,
   * which is why it is the narrower of the two clauses and is written out here
   * rather than folded into `isNetwork()`.
   *
   * The server is the real authority regardless: this decides what the UI
   * OFFERS, and the override is recorded on the order
   * (`bookorder.addressValidationOverride`) so the decision is auditable.
   */
  public canOverrideAddressValidation(): boolean {
    return this.isNetwork() || this.selectedRole === 'network';
  }

  /**
   * True when the signed-in user is allowed to choose the checkout
   * fulfillment options — the "Payee" (who gets billed: the
   * Organization, a network replacement, a service-provider
   * replacement) and the "Inventory Type" (print to order, fulfill
   * from inventory, replenish inventory).
   *
   * Those choices only make sense for someone acting on behalf of a
   * ServiceProvider or a Network: an ordinary Organization always pays
   * for its own order and always wants it printed to order. Membership
   * is read from the JWT's `cognito:groups` (see `setJwtToken`), NOT
   * from `selectedRole`, so a service-provider operator who is
   * currently acting as one of their organizations keeps the controls.
   *
   * When this returns false the checkout hides both selectors and the
   * cart is normalized to the Organization defaults — see
   * `Cart.applyDefaultFulfillmentOptions()`.
   */
  public canChooseFulfillmentOptions(): boolean {
    return this.isServiceProvider() || this.isNetwork();
  }

  selectRole(role: string, roleId: string, roleName: string) {
    if ( role !== this.selectedRole || roleId !== this.selectedRoleId ) {
      this.selectedRole = role;
      this.selectedRoleId = roleId;
      this.selectedRoleName = roleName;
      this.dataLoadingStatus = {};
      this.cart = undefined;

      this.resetCurrentOrganization();
      for ( const dataService of this.dataServices ) {
        dataService.reset();
      }
      if ( this.selectedRole ) {
        for ( const roleChangeListener of this.roleChangeListeners ) {
          try {
            roleChangeListener.roleChanged(String(this.selectedRole), this.selectedRoleId);
          } catch ( error ) {
            console.log("Error notifying a roleChangeListener " + error);
          }
        }
      }
      if ( this.notificationsService ) {
        this.notificationsService.stopNotification();
      }
      if ( this.selectedRole ) {
        if ( this.notificationsService ) {
          this.notificationsService.startNotification();
        }
        if ( this.router ) {
          this.router.navigate(['/secure/startup']);
        }
      } else {
        if ( this.router ) {
          this.router.navigate(['/home/login']);
        }
      }

      // Moved these to the end -- not sure what will happen with the router.navigate lines above
      this.onDestroySubject.next(true);
      this.onDestroySubject.unsubscribe();
    }
  }

  setAlertService(alertService: AlertService, router: Router, userLoginService: UserLoginService) {
    this.userLoginService = userLoginService;
    this.alertService = alertService;
    this.router = router;
  }

  setNotificationsService(notificationsService: NotificationsService) {
    this.notificationsService = notificationsService;
    if ( this.notificationsService ) {
      this.notificationsService.startNotification();
    }
  }
  /**
   * Public accessor for the singleton `NotificationsService`. Model-layer
   * code (e.g. `PrintNodeOrderOption` in `src/model/cart/`) needs a live
   * handle on peer data services (like `PackageTypeService`) but does not
   * receive them via DI. `NotificationsService.services` is the registry
   * where every `AbstractLiveDataService` self-registers at construction,
   * so exposing this getter lets non-DI callers reach any registered
   * peer without having to thread each service through constructors.
   *
   * Returns `undefined` early in bootstrap before
   * `NotificationsService`'s constructor has run — callers must
   * null-guard.
   */
  getNotificationsService(): NotificationsService {
    return this.notificationsService;
  }
  setPackageAndShippingComputationService(packageAndShippingComputationService: PackageAndShippingComputationService) {
    this.packageAndShippingComputationService = packageAndShippingComputationService;
  }

  touchLastUserActivity () {
    this.lastUserActivityTimestamp = Date.now();
  }

  // This is the method you want to call at bootstrap
  // Important: It should return a Promise
  // load(): Promise<any> {
  load(): any {
    // This will call itself to see if we can get things setup early
    // this.isAuthenticated(this);
  }
  isLoggedIn(message: string, isLoggedIn: boolean) {
    console.log("Startup Service confirmed things are ready by calling itself from load()");
    if ( isLoggedIn ) {
      if ( this.notificationsService ) {
        this.notificationsService.startNotification();
      }
    }
    // {
    //   if ( this.router ) {
    //     this.router.navigate(['/home/login']);
    //   }
    // }
  }

  init(jwtToken: string, email: string, name: string, phone_number: string, role: string, roleId: string, userId: string, subscriptionToken: string): any {
    this.setJwtToken(jwtToken);
    this.name = name;
    this.phone_number = phone_number;
    this.role = role;
    this.roleId = roleId;
    this.resetCurrentOrganization();
    this.email = email;
    this.userId = userId;
    this.subscriptionToken = subscriptionToken;
    this.ready = 'READY';
  }

  setOrganizationService(organizationService: OrganizationService) {
    this.organizationService = organizationService;
  }

  getProject(): Project {
    return this.project;
  }

  getJWTToken(): string {
    return this.jwtToken;
  }

  getEmail(): string {
    return this.email;
  }

  getName(): string {
    return this.name;
  }
  getRole(): string {
    return this.role;
  }
  getRoleId(): string {
    return this.roleId;
  }
  getPhoneNumber(): string {
    return this.phone_number;
  }

  // getUser(): User {
  //   if ( !this.user ) {
  //     this.user = new User( undefined );
  //     this.user.init( this.getUserId(), this.getName(), this.getEmail() );
  //   }
  //   return this.user;
  // }

  getUserId(): string {
    return 'cognito-' + this.userId;
  }

  setInteriorThemes(interiorThemes: InteriorTheme[]) {
    this.interiorThemes = interiorThemes;
  }

  setCoverThemes(coverThemes: CoverTheme[]) {
    this.coverThemes = coverThemes;
  }

  setFonts(fonts: FontItem[]) {
    this.fonts = fonts;
  }
  setColorPalettes(colorPalettes: ColorPalette[]) {
    this.colorPalettes = colorPalettes;
  }

  setProduct(product: Product) {
    this.product = product;
  }

  setProject(project: Project) {
    this.project = project;
  }

  setUserId(userId: string) {
    this.userId = userId;
  }

  getHttpOptions() {
    if ( this.selectedRole && this.selectedRoleId ) {
      return { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'accesstoken': this.getJWTToken(), 'selectedrole': this.selectedRole + '-' + this.selectedRoleId })};
    } else {
      return { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'accesstoken': this.getJWTToken() })};
    }
  }

  isAuthenticated (callback: LoggedInCallback) {
    // this.touchLastUserActivity();
    if (callback == null) {
      throw(new Error("StarupService: Callback in isAuthenticated() cannot be null"));
    }

    if (this.ready === 'READY') {
      callback.isLoggedIn(null, true);
    } else {
      try {
        this.checkSession(callback);
      } catch (e) {
        this.logout();
      }

    }
  }

  /**
   * Force a Cognito token refresh and re-run role resolution against the
   * new claims.
   *
   * Required after `POST /user/repairaccount`. The repair writes
   * `custom:roleId` onto the Cognito user, but the token already in hand
   * predates that write - so re-reading the current claims would report a
   * successful repair as a failure, which is the specific trap the server
   * called out when it shipped the endpoint.
   *
   * Deliberately routed through `setJwtToken()` rather than reading the
   * attributes here. That is the single place that decides role intent and
   * that sets/clears `accountSetupIncomplete`, so feeding it the refreshed
   * token makes the outcome self-reporting: a repair that took selects a
   * role and clears the flag, and one that did not sets the flag again.
   * Emits whether the account now has a role.
   *
   * Unlike `checkSession()` this does NOT log the operator out on failure.
   * The caller is an operator who is signed in and stuck; dropping them to
   * the login screen would discard the one token that makes repair possible.
   */
  refreshJwtToken (): Observable<boolean> {
    return new Observable<boolean>(observer => {
      const cognitoUser = this.getCurrentUser();
      if (!cognitoUser) {
        observer.error(new Error('refreshJwtToken: no current Cognito user'));
        return;
      }
      cognitoUser.getSession((err, session) => {
        if (err || !session) {
          observer.error(err || new Error('refreshJwtToken: no session'));
          return;
        }
        cognitoUser.refreshSession(session.getRefreshToken(), (error, refreshedSession) => {
          if (error || !refreshedSession) {
            observer.error(error || new Error('refreshJwtToken: refresh failed'));
            return;
          }
          this.setJwtToken(refreshedSession.getIdToken().getJwtToken());
          this.sessionRefreshTimstamp = Date.now();
          observer.next(!this.accountSetupIncomplete);
          observer.complete();
        });
      });
    });
  }
  checkSession (callback: LoggedInCallback) {
    console.log(`CheckSession [${this.ready}]`);
    if (callback === null) {
      throw(new Error("UserLoginService: Callback in checkSession() cannot be null"));
    }

    if (this.ready === 'READY') {
      callback.isLoggedIn(null, true);
    }  // else {
      const cognitoUser = this.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession((err, session) => {
          if (err) {
            console.log("UserLoginService: Couldn't get the session: " + err, err.stack);
            this.logout();
            callback.isLoggedIn(err, false);
          } else {
            try {

              this.getCurrentUser().refreshSession( session.getRefreshToken(), (error, refreshedSession) => {
                if (error) {
                  console.log("CognitoUtil: Can't refresh the refreshedSession:" + error);
                  this.logout();
                } else {
                  this.setJwtToken(refreshedSession.getIdToken().getJwtToken());

                  this.sessionRefreshTimstamp = Date.now();
                  if (!this.jwtToken || this.jwtToken.length < 20) {
                    callback.isLoggedIn("No valid authentication token", false);
                  }
                  console.log("UserLoginService: Session is " + refreshedSession.isValid());
                  cognitoUser.getUserAttributes((err2, result2) => {
                    if (err2) {
                      callback.isLoggedIn("Could not get user attributes  - " + err2.message, false);
                    } else {
                      for (let i = 0; i < result2.length; i++) {
                        console.log('CognitoUserAttributes: ' + result2[i].getName() + ' ' + result2[i].getValue());
                        switch (result2[i].getName()) {
                          case 'sub':
                            this.userId = result2[i].getValue();
                            break;
                          case 'name':
                            this.name = result2[i].getValue();
                            break;
                          case 'email':
                            this.email = result2[i].getValue();
                            break;
                          case 'custom:role':
                            this.role = result2[i].getValue();
                            break;
                          case 'custom:roleId':
                            this.roleId = result2[i].getValue();
                            // this.resetCurrentOrganization();
                            break;
                        }
                        console.log('attribute ' + result2[i].getName() + ' has value ' + result2[i].getValue());
                      }
                      this.ready = 'READY';
                      callback.isLoggedIn(null, refreshedSession.isValid());
                    }
                  });
                }
              });
            } catch (e) {
              this.logout();
            }
          }
        });
      } else {
        console.log("UserLoginService: can't retrieve the current user");
        callback.isLoggedIn("Can't retrieve the CurrentUser", false);
      }
    // }
  }

  // Copied from CognitioUtil to remove dependancy
  getUserPool() {
    if (environment.cognito_idp_endpoint) {
      CognitoUtil._POOL_DATA.endpoint = environment.cognito_idp_endpoint;
    }
    return new CognitoUserPool(CognitoUtil._POOL_DATA);
  }

  getSubscription(): Subscription {
    if ( !this.subscription ) {
      this.subscription = new Subscription(this.userId, null);
    }
    return this.subscription;
  }
  resetCurrentOrganization() {
    this.organization = undefined;
    // No Organization means no unit preference to honour; fall back to
    // the default so a stale METRIC setting from the previously
    // selected role cannot leak into the next one.
    this.setDisplayUnitSystem('IMPERIAL');
    if ( this.selectedRole ) {
      this.getCurrentOrganization();
    }
  }

  /**
   * Set the measurement system used for display and re-resolve the
   * cached unit labels.
   *
   * Always calls through to `MeasurementUnits.setUnitSystem()` even
   * when the system is unchanged: that is what drops the label cache,
   * and the labels must be re-read whenever the Organization changes
   * (a different Organization can be on a different locale-seeded
   * bundle) or whenever this runs before `AppComponent.ngOnInit()` has
   * finished seeding `LanguagePipe.map`.
   */
  public setDisplayUnitSystem(system: any): void {
    this.displayUnitSystem = MeasurementUnits.normalizeUnitSystem(system);
    MeasurementUnits.setUnitSystem(this.displayUnitSystem);
  }

  /**
   * Adopt the current Organization's display-unit preference.
   *
   * Called from every branch of `getCurrentOrganization()` once the
   * record arrives. `Organization.displayUnitSystem` is a
   * forward-declared field -- the server does not populate it yet, so
   * this is currently a no-op that reasserts `IMPERIAL` and refreshes
   * the label cache. When the column ships, this is the only place
   * that needs to already be correct.
   */
  public applyOrganizationDisplayUnits(): void {
    this.setDisplayUnitSystem(this.organization ? this.organization.displayUnitSystem : undefined);
  }

  getCurrentOrganization(): Organization {
    if ( !this.organization ) {
      if ( this.organizationService ) {
        switch ( this.selectedRole ) {
          case 'organization': {
            this.organizationService.getOrganization(this.selectedRoleId).subscribe( organization => {
              this.organization = organization;
              this.applyOrganizationDisplayUnits();
              if ( Number(this.selectedRoleId) === this.organization.ID && this.selectedRole === 'organization') {
                this.selectedRoleName = this.organization.name;
              }
            });
            break;
          }
          case 'serviceProvider': {
            this.organizationService.getServiceProviderOrganization(this.selectedRoleId).subscribe( organization => {
              this.organization = organization;
              this.applyOrganizationDisplayUnits();
              if ( Number(this.selectedRoleId) === this.organization.serviceProvider_ID && this.selectedRole === 'serviceProvider') {
                this.selectedRoleName = this.organization.name;
              }
            });
            break;
          }
          case 'umbrella': {
            this.organizationService.getUmbrellaOrganization(this.selectedRoleId).subscribe( organization => {
              this.organization = organization;
              this.applyOrganizationDisplayUnits();
              if ( Number(this.selectedRoleId) === this.organization.agent_ID && this.selectedRole === 'umbrella') {
                this.selectedRoleName = this.organization.name;
              }
            });
            break;
          }
          case 'facility': {
            this.organizationService.getOrganization(this.selectedRoleId).subscribe( organization => {
              this.organization = organization;
              this.applyOrganizationDisplayUnits();
              if ( Number(this.selectedRoleId) === this.organization.agent_ID && this.selectedRole === 'facility') {
                this.selectedRoleName = this.organization.name;
              }
            });
            break;
          }
          case 'network': {
            this.organizationService.getOrganization(this.selectedRoleId).subscribe( organization => {
              this.organization = organization;
              this.applyOrganizationDisplayUnits();
              if ( Number(this.selectedRoleId) === this.organization.agent_ID && this.selectedRole === 'network') {
                this.selectedRoleName = this.organization.name;
              }
            });
            break;
          }
          default: {
          }
        }
      }
      return undefined;
    }
    return this.organization;
  }
  getCurrentUser() {
    return this.getUserPool().getCurrentUser();
  }

  getCart(): Cart {
    if (this.cart && this.cart.items && this.cart.items.length > 0) {
      // Ensure the cart's organization is up-to-date in case the
      // startup flow swapped the current role/organization after the
      // cart was created earlier in the session.
      try { (this.cart as any).setOrganization(this.organization); } catch (e) { /* ignore */ }
      return this.cart;
    } else {
      this.cart = new Cart(undefined, this.packageAndShippingComputationService, this.organization);
      return this.cart;
    }
  }


  addService (dataService: DataService) {
    this.dataServices.push(dataService);
  }

  /**
   * Capture the Shopify install callback parameters off an inbound
   * URL query string for later consumption by the Cognito post-auth
   * flow. Safe to call repeatedly; only the most recent set of
   * params is kept. Pass `null` (or omit `shop`/`code`/`hmac`/
   * `timestamp`) to clear.
   */
  public captureShopifyInstallParams(params: {
    shop?: string;
    code?: string;
    hmac?: string;
    timestamp?: number | string;
    state?: string;
    host?: string;
  } | null): void {
    if (!params || !params.shop || !params.code || !params.hmac || params.timestamp === undefined || params.timestamp === null) {
      this.pendingShopifyParams = null;
      return;
    }
    const tsNum = typeof params.timestamp === 'string' ? Number(params.timestamp) : params.timestamp;
    if (!isFinite(tsNum as number)) {
      this.pendingShopifyParams = null;
      return;
    }
    this.pendingShopifyParams = {
      shop: params.shop,
      code: params.code,
      hmac: params.hmac,
      timestamp: tsNum as number,
      state: params.state,
      host: params.host,
    };
  }

  /**
   * Consume and clear the pending one-shot post-startup route, if
   * any. Returns the route array to pass to `Router.navigate(...)`,
   * or `null` if no override was set.
   */
  public consumePendingPostStartupRoute(): any[] | null {
    if (!this.pendingPostStartupRoute) {
      return null;
    }
    const route = this.pendingPostStartupRoute;
    this.pendingPostStartupRoute = null;
    return route;
  }
}

export interface RoleChangeNotifier {
  addRoleChangeListener(roleChangeListener): void;
}

export interface RoleChangeListener {
  roleChanged(role: string, roleId: string): void;
}


